export const mailCheck = mail => {
    if (mail && mail.length > 0) {
        return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            mail
        );
    }
    return true;
};

export const urlCheck = url => {
    if (url && url.length > 0) {
        return /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/.test(
            url
        );
    }
    return true;
};

export const formCheck = (community, logo, consent) => {
    let errors = {
        logo: false,
        name: false,
        basedIn: false,
        topics: false,
        consent: false,
    };
    if (!logo) errors.logo = true;
    if (community.name.length <= 2) errors.name = true;
    if (community.basedIn.length === 0) errors.basedIn = true;
    if (community.topics.length === 0) errors.topics = true;
    if (consent !== undefined && consent === false) errors.consent = true;
    return errors;
};

export function getCountryName(countryCode) {
    if (isoCountries.hasOwnProperty(countryCode)) {
        return isoCountries[countryCode];
    } else {
        return countryCode;
    }
}

export function getCountryCode(value, type) {
    switch (type) {
        case "country": return Object.entries(isoCountries).find(el => ~el.indexOf(value));
        case "nationality": return Object.entries(isoNationalities).find(el => ~el.indexOf(value));
        case "language": return Object.entries(isoLanguages).find(el => ~el.indexOf(value));
    }
}

export const timezones = ["Africa/Abidjan", "Africa/Accra", "Africa/Algiers", "Africa/Bissau", "Africa/Cairo", "Africa/Casablanca", "Africa/Ceuta", "Africa/El_Aaiun", "Africa/Johannesburg", "Africa/Juba", "Africa/Khartoum", "Africa/Lagos", "Africa/Maputo", "Africa/Monrovia", "Africa/Nairobi", "Africa/Ndjamena", "Africa/Sao_Tome", "Africa/Tripoli", "Africa/Tunis", "Africa/Windhoek", "America/Adak", "America/Anchorage", "America/Araguaina", "America/Argentina/Buenos_Aires", "America/Argentina/Catamarca", "America/Argentina/Cordoba", "America/Argentina/Jujuy", "America/Argentina/La_Rioja", "America/Argentina/Mendoza", "America/Argentina/Rio_Gallegos", "America/Argentina/Salta", "America/Argentina/San_Juan", "America/Argentina/San_Luis", "America/Argentina/Tucuman", "America/Argentina/Ushuaia", "America/Asuncion", "America/Atikokan", "America/Bahia", "America/Bahia_Banderas", "America/Barbados", "America/Belem", "America/Belize", "America/Blanc-Sablon", "America/Boa_Vista", "America/Bogota", "America/Boise", "America/Cambridge_Bay", "America/Campo_Grande", "America/Cancun", "America/Caracas", "America/Cayenne", "America/Chicago", "America/Chihuahua", "America/Costa_Rica", "America/Creston", "America/Cuiaba", "America/Curacao", "America/Danmarkshavn", "America/Dawson", "America/Dawson_Creek", "America/Denver", "America/Detroit", "America/Edmonton", "America/Eirunepe", "America/El_Salvador", "America/Fort_Nelson", "America/Fortaleza", "America/Glace_Bay", "America/Godthab", "America/Goose_Bay", "America/Grand_Turk", "America/Guatemala", "America/Guayaquil", "America/Guyana", "America/Halifax", "America/Havana", "America/Hermosillo", "America/Indiana/Indianapolis", "America/Indiana/Knox", "America/Indiana/Marengo", "America/Indiana/Petersburg", "America/Indiana/Tell_City", "America/Indiana/Vevay", "America/Indiana/Vincennes", "America/Indiana/Winamac", "America/Inuvik", "America/Iqaluit", "America/Jamaica", "America/Juneau", "America/Kentucky/Louisville", "America/Kentucky/Monticello", "America/La_Paz", "America/Lima", "America/Los_Angeles", "America/Maceio", "America/Managua", "America/Manaus", "America/Martinique", "America/Matamoros", "America/Mazatlan", "America/Menominee", "America/Merida", "America/Metlakatla", "America/Mexico_City", "America/Miquelon", "America/Moncton", "America/Monterrey", "America/Montevideo", "America/Nassau", "America/New_York", "America/Nipigon", "America/Nome", "America/Noronha", "America/North_Dakota/Beulah", "America/North_Dakota/Center", "America/North_Dakota/New_Salem", "America/Ojinaga", "America/Panama", "America/Pangnirtung", "America/Paramaribo", "America/Phoenix", "America/Port-au-Prince", "America/Port_of_Spain", "America/Porto_Velho", "America/Puerto_Rico", "America/Punta_Arenas", "America/Rainy_River", "America/Rankin_Inlet", "America/Recife", "America/Regina", "America/Resolute", "America/Rio_Branco", "America/Santarem", "America/Santiago", "America/Santo_Domingo", "America/Sao_Paulo", "America/Scoresbysund", "America/Sitka", "America/St_Johns", "America/Swift_Current", "America/Tegucigalpa", "America/Thule", "America/Thunder_Bay", "America/Tijuana", "America/Toronto", "America/Vancouver", "America/Whitehorse", "America/Winnipeg", "America/Yakutat", "America/Yellowknife", "Antarctica/Casey", "Antarctica/Davis", "Antarctica/DumontDUrville", "Antarctica/Macquarie", "Antarctica/Mawson", "Antarctica/Palmer", "Antarctica/Rothera", "Antarctica/Syowa", "Antarctica/Troll", "Antarctica/Vostok", "Asia/Almaty", "Asia/Amman", "Asia/Anadyr", "Asia/Aqtau", "Asia/Aqtobe", "Asia/Ashgabat", "Asia/Atyrau", "Asia/Baghdad", "Asia/Baku", "Asia/Bangkok", "Asia/Barnaul", "Asia/Beirut", "Asia/Bishkek", "Asia/Brunei", "Asia/Chita", "Asia/Choibalsan", "Asia/Colombo", "Asia/Damascus", "Asia/Dhaka", "Asia/Dili", "Asia/Dubai", "Asia/Dushanbe", "Asia/Famagusta", "Asia/Gaza", "Asia/Hebron", "Asia/Ho_Chi_Minh", "Asia/Hong_Kong", "Asia/Hovd", "Asia/Irkutsk", "Asia/Jakarta", "Asia/Jayapura", "Asia/Jerusalem", "Asia/Kabul", "Asia/Kamchatka", "Asia/Karachi", "Asia/Kathmandu", "Asia/Khandyga", "Asia/Kolkata", "Asia/Krasnoyarsk", "Asia/Kuala_Lumpur", "Asia/Kuching", "Asia/Macau", "Asia/Magadan", "Asia/Makassar", "Asia/Manila", "Asia/Nicosia", "Asia/Novokuznetsk", "Asia/Novosibirsk", "Asia/Omsk", "Asia/Oral", "Asia/Pontianak", "Asia/Pyongyang", "Asia/Qatar", "Asia/Qostanay", "Asia/Qyzylorda", "Asia/Riyadh", "Asia/Sakhalin", "Asia/Samarkand", "Asia/Seoul", "Asia/Shanghai", "Asia/Singapore", "Asia/Srednekolymsk", "Asia/Taipei", "Asia/Tashkent", "Asia/Tbilisi", "Asia/Tehran", "Asia/Thimphu", "Asia/Tokyo", "Asia/Tomsk", "Asia/Ulaanbaatar", "Asia/Urumqi", "Asia/Ust-Nera", "Asia/Vladivostok", "Asia/Yakutsk", "Asia/Yangon", "Asia/Yekaterinburg", "Asia/Yerevan", "Atlantic/Azores", "Atlantic/Bermuda", "Atlantic/Canary", "Atlantic/Cape_Verde", "Atlantic/Faroe", "Atlantic/Madeira", "Atlantic/Reykjavik", "Atlantic/South_Georgia", "Atlantic/Stanley", "Australia/Adelaide", "Australia/Brisbane", "Australia/Broken_Hill", "Australia/Currie", "Australia/Darwin", "Australia/Eucla", "Australia/Hobart", "Australia/Lindeman", "Australia/Lord_Howe", "Australia/Melbourne", "Australia/Perth", "Australia/Sydney", "CET", "CST6CDT", "EET", "EST", "EST5EDT", "Etc/GMT", "Etc/GMT+1", "Etc/GMT+10", "Etc/GMT+11", "Etc/GMT+12", "Etc/GMT+2", "Etc/GMT+3", "Etc/GMT+4", "Etc/GMT+5", "Etc/GMT+6", "Etc/GMT+7", "Etc/GMT+8", "Etc/GMT+9", "Etc/GMT-1", "Etc/GMT-10", "Etc/GMT-11", "Etc/GMT-12", "Etc/GMT-13", "Etc/GMT-14", "Etc/GMT-2", "Etc/GMT-3", "Etc/GMT-4", "Etc/GMT-5", "Etc/GMT-6", "Etc/GMT-7", "Etc/GMT-8", "Etc/GMT-9", "Etc/UTC", "Europe/Amsterdam", "Europe/Andorra", "Europe/Astrakhan", "Europe/Athens", "Europe/Belgrade", "Europe/Berlin", "Europe/Brussels", "Europe/Bucharest", "Europe/Budapest", "Europe/Chisinau", "Europe/Copenhagen", "Europe/Dublin", "Europe/Gibraltar", "Europe/Helsinki", "Europe/Istanbul", "Europe/Kaliningrad", "Europe/Kiev", "Europe/Kirov", "Europe/Lisbon", "Europe/London", "Europe/Luxembourg", "Europe/Madrid", "Europe/Malta", "Europe/Minsk", "Europe/Monaco", "Europe/Moscow", "Europe/Oslo", "Europe/Paris", "Europe/Prague", "Europe/Riga", "Europe/Rome", "Europe/Samara", "Europe/Saratov", "Europe/Simferopol", "Europe/Sofia", "Europe/Stockholm", "Europe/Tallinn", "Europe/Tirane", "Europe/Ulyanovsk", "Europe/Uzhgorod", "Europe/Vienna", "Europe/Vilnius", "Europe/Volgograd", "Europe/Warsaw", "Europe/Zaporozhye", "Europe/Zurich", "HST", "Indian/Chagos", "Indian/Christmas", "Indian/Cocos", "Indian/Kerguelen", "Indian/Mahe", "Indian/Maldives", "Indian/Mauritius", "Indian/Reunion", "MET", "MST", "MST7MDT", "PST8PDT", "Pacific/Apia", "Pacific/Auckland", "Pacific/Bougainville", "Pacific/Chatham", "Pacific/Chuuk", "Pacific/Easter", "Pacific/Efate", "Pacific/Enderbury", "Pacific/Fakaofo", "Pacific/Fiji", "Pacific/Funafuti", "Pacific/Galapagos", "Pacific/Gambier", "Pacific/Guadalcanal", "Pacific/Guam", "Pacific/Honolulu", "Pacific/Kiritimati", "Pacific/Kosrae", "Pacific/Kwajalein", "Pacific/Majuro", "Pacific/Marquesas", "Pacific/Nauru", "Pacific/Niue", "Pacific/Norfolk", "Pacific/Noumea", "Pacific/Pago_Pago", "Pacific/Palau", "Pacific/Pitcairn", "Pacific/Pohnpei", "Pacific/Port_Moresby", "Pacific/Rarotonga", "Pacific/Tahiti", "Pacific/Tarawa", "Pacific/Tongatapu", "Pacific/Wake", "Pacific/Wallis", "WET"]

export const isoCountries = {
    AF: "Afghanistan",
    AX: "Aland Islands",
    AL: "Albania",
    DZ: "Algeria",
    AS: "American Samoa",
    AD: "Andorra",
    AO: "Angola",
    AI: "Anguilla",
    AQ: "Antarctica",
    AG: "Antigua And Barbuda",
    AR: "Argentina",
    AM: "Armenia",
    AW: "Aruba",
    AU: "Australia",
    AT: "Austria",
    AZ: "Azerbaijan",
    BS: "Bahamas",
    BH: "Bahrain",
    BD: "Bangladesh",
    BB: "Barbados",
    BY: "Belarus",
    BE: "Belgium",
    BZ: "Belize",
    BJ: "Benin",
    BM: "Bermuda",
    BT: "Bhutan",
    BO: "Bolivia",
    BA: "Bosnia And Herzegovina",
    BW: "Botswana",
    BV: "Bouvet Island",
    BR: "Brazil",
    IO: "British Indian Ocean Territory",
    BN: "Brunei Darussalam",
    BG: "Bulgaria",
    BF: "Burkina Faso",
    BI: "Burundi",
    KH: "Cambodia",
    CM: "Cameroon",
    CA: "Canada",
    CV: "Cape Verde",
    KY: "Cayman Islands",
    CF: "Central African Republic",
    TD: "Chad",
    CL: "Chile",
    CN: "China",
    CX: "Christmas Island",
    CC: "Cocos (Keeling) Islands",
    CO: "Colombia",
    KM: "Comoros",
    CG: "Congo",
    CD: "Congo, Democratic Republic",
    CK: "Cook Islands",
    CR: "Costa Rica",
    CI: "Cote D'Ivoire",
    HR: "Croatia",
    CU: "Cuba",
    CY: "Cyprus",
    CZ: "Czech Republic",
    DK: "Denmark",
    DJ: "Djibouti",
    DM: "Dominica",
    DO: "Dominican Republic",
    EC: "Ecuador",
    EG: "Egypt",
    SV: "El Salvador",
    GQ: "Equatorial Guinea",
    ER: "Eritrea",
    EE: "Estonia",
    ET: "Ethiopia",
    FK: "Falkland Islands (Malvinas)",
    FO: "Faroe Islands",
    FJ: "Fiji",
    FI: "Finland",
    FR: "France",
    GF: "French Guiana",
    PF: "French Polynesia",
    TF: "French Southern Territories",
    GA: "Gabon",
    GM: "Gambia",
    GE: "Georgia",
    DE: "Germany",
    GH: "Ghana",
    GI: "Gibraltar",
    GR: "Greece",
    GL: "Greenland",
    GD: "Grenada",
    GP: "Guadeloupe",
    GU: "Guam",
    GT: "Guatemala",
    GG: "Guernsey",
    GN: "Guinea",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HT: "Haiti",
    HM: "Heard Island & Mcdonald Islands",
    VA: "Holy See (Vatican City State)",
    HN: "Honduras",
    HK: "Hong Kong",
    HU: "Hungary",
    IS: "Iceland",
    IN: "India",
    ID: "Indonesia",
    IR: "Iran, Islamic Republic Of",
    IQ: "Iraq",
    IE: "Ireland",
    IM: "Isle Of Man",
    IL: "Israel",
    IT: "Italy",
    JM: "Jamaica",
    JP: "Japan",
    JE: "Jersey",
    JO: "Jordan",
    KZ: "Kazakhstan",
    KE: "Kenya",
    KI: "Kiribati",
    KR: "Korea",
    KW: "Kuwait",
    KG: "Kyrgyzstan",
    LA: "Lao People's Democratic Republic",
    LV: "Latvia",
    LB: "Lebanon",
    LS: "Lesotho",
    LR: "Liberia",
    LY: "Libyan Arab Jamahiriya",
    LI: "Liechtenstein",
    LT: "Lithuania",
    LU: "Luxembourg",
    MO: "Macao",
    MK: "Macedonia",
    MG: "Madagascar",
    MW: "Malawi",
    MY: "Malaysia",
    MV: "Maldives",
    ML: "Mali",
    MT: "Malta",
    MH: "Marshall Islands",
    MQ: "Martinique",
    MR: "Mauritania",
    MU: "Mauritius",
    YT: "Mayotte",
    MX: "Mexico",
    FM: "Micronesia, Federated States Of",
    MD: "Moldova",
    MC: "Monaco",
    MN: "Mongolia",
    ME: "Montenegro",
    MS: "Montserrat",
    MA: "Morocco",
    MZ: "Mozambique",
    MM: "Myanmar",
    NA: "Namibia",
    NR: "Nauru",
    NP: "Nepal",
    NL: "Netherlands",
    AN: "Netherlands Antilles",
    NC: "New Caledonia",
    NZ: "New Zealand",
    NI: "Nicaragua",
    NE: "Niger",
    NG: "Nigeria",
    NU: "Niue",
    NF: "Norfolk Island",
    MP: "Northern Mariana Islands",
    NO: "Norway",
    OM: "Oman",
    PK: "Pakistan",
    PW: "Palau",
    PS: "Palestinian Territory, Occupied",
    PA: "Panama",
    PG: "Papua New Guinea",
    PY: "Paraguay",
    PE: "Peru",
    PH: "Philippines",
    PN: "Pitcairn",
    PL: "Poland",
    PT: "Portugal",
    PR: "Puerto Rico",
    QA: "Qatar",
    RE: "Reunion",
    RO: "Romania",
    RU: "Russian Federation",
    RW: "Rwanda",
    BL: "Saint Barthelemy",
    SH: "Saint Helena",
    KN: "Saint Kitts And Nevis",
    LC: "Saint Lucia",
    MF: "Saint Martin",
    PM: "Saint Pierre And Miquelon",
    VC: "Saint Vincent And Grenadines",
    WS: "Samoa",
    SM: "San Marino",
    ST: "Sao Tome And Principe",
    SA: "Saudi Arabia",
    SN: "Senegal",
    RS: "Serbia",
    SC: "Seychelles",
    SL: "Sierra Leone",
    SG: "Singapore",
    SK: "Slovakia",
    SI: "Slovenia",
    SB: "Solomon Islands",
    SO: "Somalia",
    ZA: "South Africa",
    GS: "South Georgia And Sandwich Isl.",
    ES: "Spain",
    LK: "Sri Lanka",
    SD: "Sudan",
    SR: "Suriname",
    SJ: "Svalbard And Jan Mayen",
    SZ: "Swaziland",
    SE: "Sweden",
    CH: "Switzerland",
    SY: "Syrian Arab Republic",
    TW: "Taiwan",
    TJ: "Tajikistan",
    TZ: "Tanzania",
    TH: "Thailand",
    TL: "Timor-Leste",
    TG: "Togo",
    TK: "Tokelau",
    TO: "Tonga",
    TT: "Trinidad And Tobago",
    TN: "Tunisia",
    TR: "Turkey",
    TM: "Turkmenistan",
    TC: "Turks And Caicos Islands",
    TV: "Tuvalu",
    UG: "Uganda",
    UA: "Ukraine",
    AE: "United Arab Emirates",
    GB: "United Kingdom",
    US: "United States",
    UM: "United States Outlying Islands",
    UY: "Uruguay",
    UZ: "Uzbekistan",
    VU: "Vanuatu",
    VE: "Venezuela",
    VN: "Viet Nam",
    VG: "Virgin Islands, British",
    VI: "Virgin Islands, U.S.",
    WF: "Wallis And Futuna",
    EH: "Western Sahara",
    YE: "Yemen",
    ZM: "Zambia",
    ZW: "Zimbabwe"
};
export const isoLanguages = {
    AF: 'Afrikanns',
    SQ: 'Albanian',
    AR: 'Arabic',
    HY: 'Armenian',
    EU: 'Basque',
    BN: 'Bengali',
    BG: 'Bulgarian',
    CA: 'Catalan',
    KM: 'Cambodian',
    ZH: 'Chinese (Mandarin)',
    HR: 'Croatian',
    CS: 'Czech',
    DA: 'Danish',
    NL: 'Dutch',
    EN: 'English',
    ET: 'Estonian',
    FJ: 'Fiji',
    FI: 'Finnish',
    FR: 'French',
    KA: 'Georgian',
    DE: 'German',
    EL: 'Greek',
    GU: 'Gujarati',
    HE: 'Hebrew',
    HI: 'Hindi',
    HU: 'Hungarian',
    IS: 'Icelandic',
    ID: 'Indonesian',
    GA: 'Irish',
    IT: 'Italian',
    JA: 'Japanese',
    JW: 'Javanese',
    KO: 'Korean',
    LA: 'Latin',
    LV: 'Latvian',
    LT: 'Lithuanian',
    MK: 'Macedonian',
    MS: 'Malay',
    ML: 'Malayalam',
    MT: 'Maltese',
    MI: 'Maori',
    MR: 'Marathi',
    MN: 'Mongolian',
    NE: 'Nepali',
    NO: 'Norwegian',
    FA: 'Persian',
    PL: 'Polish',
    PT: 'Portuguese',
    PA: 'Punjabi',
    QU: 'Quechua',
    RO: 'Romanian',
    RU: 'Russian',
    SM: 'Samoan',
    SR: 'Serbian',
    SK: 'Slovak',
    SL: 'Slovenian',
    ES: 'Spanish',
    SW: 'Swahili',
    SV: 'Swedish ',
    TA: 'Tamil',
    TT: 'Tatar',
    TE: 'Telugu',
    TH: 'Thai',
    BO: 'Tibetan',
    TO: 'Tonga',
    TR: 'Turkish',
    UK: 'Ukranian',
    UR: 'Urdu',
    UZ: 'Uzbek',
    VI: 'Vietnamese',
    CY: 'Welsh',
    XH: 'Xhosa'
};
export const isoNationalities = {
    AD: "Andorran"
    , AE: "Emirati, Emirian, Emiri"
    , AF: "Afghan"
    , AG: "Antiguan or Barbudan"
    , AI: "Anguillan"
    , AL: "Albanian"
    , AM: "Armenian"
    , AO: "Angolan"
    , AQ: "Antarctic"
    , AR: "Argentine"
    , AS: "American Samoan"
    , AT: "Austrian"
    , AU: "Australian"
    , AW: "Aruban"
    , AX: "Åland Island"
    , AZ: "Azerbaijani, Azeri"
    , BA: "Bosnian or Herzegovinian"
    , BB: "Barbadian"
    , BD: "Bangladeshi"
    , BE: "Belgian"
    , BF: "Burkinabé"
    , BG: "Bulgarian"
    , BH: "Bahraini"
    , BI: "Burundian"
    , BJ: "Beninese, Beninois"
    , BL: "Barthélemois"
    , BM: "Bermudian, Bermudan"
    , BN: "Bruneian"
    , BO: "Bolivian"
    , BQ: "Bonaire"
    , BR: "Brazilian"
    , BS: "Bahamian"
    , BT: "Bhutanese"
    , BV: "Bouvet Island"
    , BW: "Motswana, Botswanan"
    , BY: "Belarusian"
    , BZ: "Belizean"
    , CA: "Canadian"
    , CC: "Cocos Island"
    , CD: "Congolese"
    , CF: "Central African"
    , CG: "Congolese"
    , CH: "Swiss"
    , CI: "Ivorian"
    , CK: "Cook Island"
    , CL: "Chilean"
    , CM: "Cameroonian"
    , CN: "Chinese"
    , CO: "Colombian"
    , CR: "Costa Rican"
    , CU: "Cuban"
    , CV: "Cabo Verdean"
    , CW: "Curaçaoan"
    , CX: "Christmas Island"
    , CY: "Cypriot"
    , CZ: "Czech"
    , DE: "German"
    , DJ: "Djiboutian"
    , DK: "Danish"
    , DM: "Dominican"
    , DO: "Dominican"
    , DZ: "Algerian"
    , EC: "Ecuadorian"
    , EE: "Estonian"
    , EG: "Egyptian"
    , EH: "Sahrawi, Sahrawian, Sahraouian"
    , ER: "Eritrean"
    , ES: "Spanish"
    , ET: "Ethiopian"
    , FI: "Finnish"
    , FJ: "Fijian"
    , FK: "Falkland Island"
    , FM: "Micronesian"
    , FO: "Faroese"
    , FR: "French"
    , GA: "Gabonese"
    , GB: "British, UK"
    , GD: "Grenadian"
    , GE: "Georgian"
    , GF: "French Guianese"
    , GG: "Channel Island"
    , GH: "Ghanaian"
    , GI: "Gibraltar"
    , GL: "Greenlandic"
    , GM: "Gambian"
    , GN: "Guinean"
    , GP: "Guadeloupe"
    , GQ: "Equatorial Guinean, Equatoguinean"
    , GR: "Greek, Hellenic"
    , GS: "South Georgia or South Sandwich Islands"
    , GT: "Guatemalan"
    , GU: "Guamanian, Guambat"
    , GW: "Bissau-Guinean"
    , GY: "Guyanese"
    , HK: "Hong Kong, Hong Kongese"
    , HM: "Heard Island or McDonald Islands"
    , HN: "Honduran"
    , HR: "Croatian"
    , HT: "Haitian"
    , HU: "Hungarian, Magyar"
    , ID: "Indonesian"
    , IE: "Irish"
    , IL: "Israeli"
    , IM: "Manx"
    , IN: "Indian"
    , IO: "BIOT"
    , IQ: "Iraqi"
    , IR: "Iranian, Persian"
    , IS: "Icelandic"
    , IT: "Italian"
    , JE: "Channel Island"
    , JM: "Jamaican"
    , JO: "Jordanian"
    , JP: "Japanese"
    , KE: "Kenyan"
    , KG: "Kyrgyzstani, Kyrgyz, Kirgiz, Kirghiz"
    , KH: "Cambodian"
    , KI: "I-Kiribati"
    , KM: "Comoran, Comorian"
    , KN: "Kittitian or Nevisian"
    , KP: "North Korean"
    , KR: "South Korean"
    , KW: "Kuwaiti"
    , KY: "Caymanian"
    , KZ: "Kazakhstani, Kazakh"
    , LA: "Lao, Laotian"
    , LB: "Lebanese"
    , LC: "Saint Lucian"
    , LI: "Liechtenstein"
    , LK: "Sri Lankan"
    , LR: "Liberian"
    , LS: "Basotho"
    , LT: "Lithuanian"
    , LU: "Luxembourg, Luxembourgish"
    , LV: "Latvian"
    , LY: "Libyan"
    , MA: "Moroccan"
    , MC: "Monégasque, Monacan"
    , MD: "Moldovan"
    , ME: "Montenegrin"
    , MF: "Saint-Martinoise"
    , MG: "Malagasy"
    , MH: "Marshallese"
    , MK: "Macedonian"
    , ML: "Malian, Malinese"
    , MM: "Burmese"
    , MN: "Mongolian"
    , MO: "Macanese, Chinese"
    , MP: "Northern Marianan"
    , MQ: "Martiniquais, Martinican"
    , MR: "Mauritanian"
    , MS: "Montserratian"
    , MT: "Maltese"
    , MU: "Mauritian"
    , MV: "Maldivian"
    , MW: "Malawian"
    , MX: "Mexican"
    , MY: "Malaysian"
    , MZ: "Mozambican"
    , NA: "Namibian"
    , NC: "New Caledonian"
    , NE: "Nigerien"
    , NF: "Norfolk Island"
    , NG: "Nigerian"
    , NI: "Nicaraguan"
    , NL: "Dutch, Netherlandic"
    , NO: "Norwegian"
    , NP: "Nepali, Nepalese"
    , NR: "Nauruan"
    , NU: "Niuean"
    , NZ: "New Zealand, NZ"
    , OM: "Omani"
    , PA: "Panamanian"
    , PE: "Peruvian"
    , PF: "French Polynesian"
    , PG: "Papua New Guinean, Papuan"
    , PH: "Philippine, Filipino"
    , PK: "Pakistani"
    , PL: "Polish"
    , PM: "Saint-Pierrais or Miquelonnais"
    , PN: "Pitcairn Island"
    , PR: "Puerto Rican"
    , PS: "Palestinian"
    , PT: "Portuguese"
    , PW: "Palauan"
    , PY: "Paraguayan"
    , QA: "Qatari"
    , RE: "Réunionese, Réunionnais"
    , RO: "Romanian"
    , RS: "Serbian"
    , RU: "Russian"
    , RW: "Rwandan"
    , SA: "Saudi, Saudi Arabian"
    , SB: "Solomon Island"
    , SC: "Seychellois"
    , SD: "Sudanese"
    , SE: "Swedish"
    , SG: "Singaporean"
    , SH: "Saint Helenian"
    , SI: "Slovenian, Slovene"
    , SJ: "Svalbard"
    , SK: "Slovak"
    , SL: "Sierra Leonean"
    , SM: "Sammarinese"
    , SN: "Senegalese"
    , SO: "Somali, Somalian"
    , SR: "Surinamese"
    , SS: "South Sudanese"
    , ST: "São Toméan"
    , SV: "Salvadoran"
    , SX: "Sint Maarten"
    , SY: "Syrian"
    , SZ: "Swazi"
    , TC: "Turks and Caicos Island"
    , TD: "Chadian"
    , TF: "French Southern Territories"
    , TG: "Togolese"
    , TH: "Thai"
    , TJ: "Tajikistani"
    , TK: "Tokelauan"
    , TL: "Timorese"
    , TM: "Turkmen"
    , TN: "Tunisian"
    , TO: "Tongan"
    , TR: "Turkish"
    , TT: "Trinidadian or Tobagonian"
    , TV: "Tuvaluan"
    , TW: "Chinese, Taiwanese"
    , TZ: "Tanzanian"
    , UA: "Ukrainian"
    , UG: "Ugandan"
    , UM: "American"
    , US: "American"
    , UY: "Uruguayan"
    , UZ: "Uzbekistani, Uzbek"
    , VA: "Vatican"
    , VC: "Saint Vincentian, Vincentian"
    , VE: "Venezuelan"
    , VG: "British Virgin Island"
    , VI: "U.S. Virgin Island"
    , VN: "Vietnamese"
    , VU: "Ni-Vanuatu, Vanuatuan"
    , WF: "Wallis and Futuna, Wallisian or Futunan"
    , WS: "Samoan"
    , YE: "Yemeni"
    , YT: "Mahoran"
    , ZA: "South African"
    , ZM: "Zambian"
    , ZW: "Zimbabwean"
}
